import { Component } from "@angular/core";
import { ModalController, NavController, NavParams } from "ionic-angular";
import { TopicAnswersModal } from "../topic-answers.modal/topic-answers.modal";
import { Topic, TopicItem } from "../../../../app/models/types";
import { TopicInfoModal } from "../topic-info.modal/topic-info.modal";
import { DiaprofilPatient } from "../../../../app/models/diaprofil-patient";
import { DiaprofilProTask } from "../../../../app/models/diaprofil-pro-task";

@Component({
  selector: "topic-card-popover",
  templateUrl: "topic-card.popover.html"
})
export class TopicCardPopover {
  topic: Topic;
  topicItems: TopicItem[];
  patient: DiaprofilPatient;
  task: DiaprofilProTask;
  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private navParams: NavParams
  ) {
    this.topic = this.navParams.get("topic") || {};
    this.topicItems = this.navParams.get("topicItems") || [];
    this.patient = this.navParams.get("patient") || {};
    this.task = this.navParams.get("task") || {};
  }

  openInfoModal() {
    const data = {
      topic: this.topic,
      topicItems: this.topicItems
    };
    const modal = this.modalCtrl.create(TopicInfoModal, data);
    modal.present();
    this.navCtrl.pop();
  }

  openAllAnswersModal() {
    const data = {
      topic: this.topic,
      topicItems: this.topicItems,
      patient: this.patient,
      task: this.task
    };
    const modal = this.modalCtrl.create(TopicAnswersModal, data);
    modal.present();
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.page/topic-card.component/topic-card.popover/topic-card.popover.ts